import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '@api/api.service';
import { FolderCreate } from '@api/types';
import { ModalService } from '@shared/modal/modal.service';
import { SidebarService } from '@shared/services/sidebar.service';

@Component({
  selector: 'rav-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss']
})
export class CreateFolderComponent implements OnInit {
  @Input() parentId: string;
  @Input() launchNewFolder = false;
  @Input() modalId = 'newFolder';

  formGroup: FormGroup;
  isCreating = false;

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private sidebar: SidebarService,
    public modal: ModalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.buildFormGroup();
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      title: new FormControl('', Validators.required)
    });
  }

  async createFolder(newFolder: FolderCreate) {
    if (this.isCreating) return; // prevent multiple folders from being spam created
    this.isCreating = true;
    newFolder.parent_id = this.parentId;
    await this.api.folders
      .post(newFolder)
      .toPromise()
      .then(
        (folder) => {
          this.sidebar.createdFolder.emit(folder);
          this.buildFormGroup();
          this.isCreating = false;
          this.modal.close.next({ modalId: this.modalId });
          if (this.launchNewFolder) this.router.navigateByUrl(`/folders/${folder.id}`);
        },
        (error) => {
          this.api.onFormError(error, this.formGroup);
          this.isCreating = false;
        }
      );
  }
}
